/**
 * @class pagingComposition.
 *
 */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PagingTable from './pagingTable';
export default (entity, actionCreators, attributeMap = {}) => {
  /*  ----------------------------------------------------
   + These methods allow you to massage variables into properties passed in
   + props to the component.
   +
   + The first takes the (global) redux state as input, and outputs just the
   + relevant parts to the compoment.
   + */
  // map the redux store/state into props for this component.
  const mapStateToProps = state => ({
    // we can filter or otherwise manipulate the state props here.
    hasPrevious: state[entity].hasPrevious,
    hasNext: state[entity].hasNext,
    indexQuery: state[entity].indexQuery,
    attributeMap
  });

  // map the redux dipsatch mechanism into actions prop for this component.
  const mapDispatchToProps = dispatch => {
    const actions = bindActionCreators(actionCreators, dispatch);
    // initialize the paging...
    return {
      handlePreviousPage: actions.pagePrevious,
      handleNextPage: actions.pageNext,
      sortBy: actions.sortBy
    };
  };

  // This wraps and instance of pagingTable and
  // connects it to the subset of the redux state as well as the action set
  return connect(mapStateToProps, mapDispatchToProps)(PagingTable);
};